import 'mapbox-gl/dist/mapbox-gl.css';

import React from 'react';
import MapViewer from './map';
import Montana from './montana.json';
import MapData from './map-data';
import { GEOLOCATION_HEALTH_REPORT_URL } from '../../services/config';

class Map extends React.Component {

  mapData = new MapData(GEOLOCATION_HEALTH_REPORT_URL);

  state = {
    data: null
  };

  componentDidMount() {
    this.mapData.on('data', data => this.setState({ data }));

    this.mapData.start()
      .catch((error) => {
        console.error('Error starting map data fetcher');
        console.error(error);
      })
  }

  componentWillUnmount() {
    this.mapData.cancel()
      .catch((error) => {
        console.error('Error cancelling map data fetcher');
        console.error(error);
      })
  }

  render() {
    if (!this.state.data) {
      return <p>Loading....</p>
    }
    return <MapViewer data={this.state.data} region={Montana} />;
  }
}

export default Map;


// WEBPACK FOOTER //
// ./src/app/map/index.js